/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, hour: NonNullable<unknown>, count: NonNullable<unknown> }} Statistics_TooltipInputs */

const he_statistics_tooltip = /** @type {(inputs: Statistics_TooltipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} ${i?.hour}:00 — ${i?.count} אירועים`)
};

const en_statistics_tooltip = /** @type {(inputs: Statistics_TooltipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} ${i?.hour}:00 — ${i?.count} events`)
};

/**
* | output |
* | --- |
* | "{day} {hour}:00 — {count} events" |
*
* @param {Statistics_TooltipInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_tooltip = /** @type {((inputs: Statistics_TooltipInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_TooltipInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_tooltip(inputs)
	return en_statistics_tooltip(inputs)
});